var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NextBtn',_vm._g(_vm._b({style:({ marginRight: '20px', color: '#150E8B', borderColor: '#150E8B' })},'NextBtn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }